import { CssRender as e } from "./highrise375.mjs";
const { c } = e(), o = "vueuc-style";
export {
  c,
  o as cssrAnchorMetaName
};
